export default __webpack_public_path__ + "static/media/006-brush.33704593.svg";